<!-- 首页//用能趋势分析  -->
<template>
  <div class="box">
    <Title :text="home.EnergyConsumptionTrend.Title[0]" :engText="home.EnergyConsumptionTrend.Title[1]"></Title>
     <div class="content">
      <div class="content-title">
        <div class="a1">
          [
          <div :class="`${active === 1 ? 'active' : ''}`" @click="fn1(1)">本日</div>
          <div :class="`${active === 2 ? 'active' : ''}`" @click="fn1(2)">本月</div>
          <div :class="`${active === 3 ? 'active' : ''}`" @click="fn1(3)">本年</div>
          ]
        </div>
        <div class="a2">
          <div>
            <div class="b0"></div>
            <div class="c">总</div>
          </div>
          <div>
            <div class="b1"></div>
            <div class="c">水</div>
          </div>
          <div>
            <div class="b2"></div>
            <div class="c">电</div>
          </div>
        </div>
      </div>
      <div class="echarts-content">
      <chart-block ref="chart"></chart-block>
    </div>
    </div>
  </div>
</template>

<script>
import Title from '../../components/title/index.vue';
import { mapState,mapActions } from 'pinia' //引入映射函数
import useStore from '@/store/index' //引入store
export default {
  components: {
    Title,
  },
  computed:{
    ...mapState(useStore,['home']) 
  },
 data () {
    return {
      // active 1:日，2:月，3:年
      active:1,
    }
  },
  mounted () {
    this.$refs.chart.setOption(this.home.EnergyConsumptionTrend.Option);
  },
  methods: {
    fn1(i){
      this.active = i;
    }
  }
}
</script>

<style scoped>
.box{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.content{
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.content-title{
  width: 100%;
  height: 53px;
  display: flex;
  flex-direction: column;
}
.content-title .a1{
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-title .a1 > div{
  margin: 0px 10px;
  font-size: 12px;
  cursor: pointer;
}
.content-title .a2{
  flex: 1;
  display: flex;
  justify-content: right;
}
.content-title .a2 > div{
  display: flex;
  align-items: center;
  font-size: 12px;

}
.content-title .a2 > div:nth-child(2){
  margin: 0px 10px;
}
.content-title .a2 .b0{
  width: 7px;
  height: 7px;
  background-color: #f4f4f4;
  /* background: #ffb400; */
}
.content-title .a2 .b1{
  width: 7px;
  height: 7px;
  background-color: #488dff;
  /* background: #ffb400; */
}
.content-title .a2 .b2{
  width: 7px;
  height: 7px;
  background: #ffb400;
}
.content-title .a2 .c{
  transform: scale(.8);
}
.active{
  text-shadow: 0px 4px 5px #488dff;
}
</style>